import React from "react";

export default function ShareSoundCta() {
  return (
    <section className="mu-section pt-0">
      <div className="container">
        <div className="share-sound-cta">
          <div className="d-flex align-items-center gap-3">
            <div className="share-sound-avatar">
              <img src="https://picsum.photos/seed/mu-share-sound/64/64" alt="" />
            </div>
            <div>
              <h3>Ready to Share Your Sound?</h3>
              <p>Send an email to submit your music and get in front of new listeners in days, not months.</p>
            </div>
          </div>
          <a href="#submit-music" className="btn-mu-solid flex-shrink-0">Submit Music &rarr;</a>
        </div>
      </div>
    </section>
  );
}
